module.exports = __webpack_public_path__ + "static/media/yoga-old-man.1bd7b094.jpg";